<template>
  <div>
    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.payment') }}</h2>
      <div class="info-group">
        <div class="info-item">
          <label>{{ $t('crm.paymentMethod') }}</label>
          <div class="value">{{ detail.paymentMethod || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.depositAmount') }}</label>
          <div class="value">{{ detail.depositAmount || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.paymentTiming') }}</label>
          <div class="value">
            {{ detail.paymentTiming || '-' }}<span v-if="detail.paymentTimingRemark">({{ detail.paymentTimingRemark }})</span>
          </div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.paymentRemark') }}</label>
          <div class="value">{{ detail.paymentMethodRemark || '-' }}</div>
        </div>
        <div class="info-item" v-if="detail.paymentTimingTime">
          <label>{{ $t('crm.settlementCycle') }}</label>
          <div class="value">{{ $t('common.week' + (detail.paymentTimingTime - 1)) }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.vendorSettlementCurrency') }}</label>
          <div class="value">{{ detail.settleCurrency || '-' }}</div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.pricingInfo') }}</h2>
      <div class="info-group">
        <div class="info-item">
          <label>{{ $t('crm.vendorName') }}</label>
          <div class="value">{{ detail.vendorName || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.retailPriceIncludesTax') }}</label>
          <div class="value">{{ detail.retailPriceIncludingTax || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.vendorLoginAccount') }}</label>
          <div class="value">{{ detail.userName || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.supplyPriceIncludesTax') }}</label>
          <div class="value">{{ detail.supplyMethodIncludingTax || '-' }}</div>
        </div>
        <!-- <div class="info-item">
          <label>{{ $t('crm.ifIMCanGetTaxBack') }}</label>
          <div class="value">{{ detail.drawback || '-' }}</div>
        </div> -->
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.billingInfo') }}</h2>
      <div class="info-group">
        <div class="info-item">
          <label>{{ $t('crm.companyName') }}</label>
          <div class="value">{{ detail.companyName || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.vatNumber') }}</label>
          <div class="value">{{ detail.businessLicenseNumber || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('common.country') }}</label>
          <div class="value">{{ detail.countryName || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('common.city') }}</label>
          <div class="value">{{ detail.cityName || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('common.postCode') }}</label>
          <div class="value">{{ detail.postalCode || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('common.address') }}</label>
          <div class="value">{{ detail.businessLicenseLocation || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.contactPerson') }}</label>
          <div class="value">{{ detail.contactPerson || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.contactEmail') }}</label>
          <div class="value">{{ detail.contactEmail || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.contactPhoneNumber') }}</label>
          <div class="value">{{ detail.contactPhone || '-' }}</div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.payeeInfo') }}</h2>
      <el-table :data="tableData" :header-cell-style="{backgroundColor: '#f0f0f0'}" border>
        <el-table-column prop="payeeName" :label="$t('crm.payeeName')"></el-table-column>
        <el-table-column prop="bankOfName" :label="$t('crm.bankName')"></el-table-column>
        <el-table-column prop="bankAccountNo" :label="$t('crm.bankAccount')"></el-table-column>
        <el-table-column prop="bankAddress" :label="$t('crm.bankAddress')"></el-table-column>
        <el-table-column prop="swiftCode" :label="$t('crm.swiftCode')"></el-table-column>
        <el-table-column prop="iban" :label="$t('crm.iban')"></el-table-column>
        <el-table-column prop="payType" :label="$t('crm.payMethod')">
          <template slot-scope="scope">
              {{scope.row.payType==1?$t('crm.overseaPayment'):$t('crm.domesticPayment') }}
          </template>
       </el-table-column>
        <el-table-column prop="idNo" :label="$t('crm.idNumber')"></el-table-column>
        <el-table-column prop="phoneNum" :label="$t('crm.phoneNumber')"></el-table-column>
        <el-table-column prop="defaultOption" :label="$t('crm.defaultOption')">
          <template slot-scope="scope">{{scope.row.defaultOption === 1 ? $t('common.yes') : scope.row.defaultOption === 0 ? $t('common.no') : "" }}</template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import {
  getVendorPayment,
  getVendorPriceInfo,
  getVendorInvoice,
  getVendorReceivePayment,
} from '../api';

export default {
  data() {
    return {
      detail: {},
      tableData: [],
    };
  },
  mounted() {
    getVendorPayment({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.detail = {
          ...this.detail,
          ...res.data.data,
        };
      }
    });
    getVendorPriceInfo({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.detail = {
          ...this.detail,
          ...res.data.data,
        };
      }
    });
    getVendorInvoice({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.detail = {
          ...this.detail,
          ...res.data.data,
        };
      }
    });
    getVendorReceivePayment({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.tableData = res.data.data;
      }
    });
  },
}
</script>

<style lang="less" scoped>
.box-card {
  margin-bottom: 20px;
}
.info-group {
  display: flex;
  flex-wrap: wrap;
}
.info-item {
  display: flex;
  width: 50%;
  line-height: 20px;

  label {
    flex: 0 0 auto;
    width: 200px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #EBEEF5;
  }
  .value {
    flex: 1;
    padding: 10px;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  &:nth-child(even) {
    label {
      border-left: 0;
    }
  }
  &:nth-child(n+3) {
    label {
      border-top: 0;
    }
    .value {
      border-top: 0;
    }
  }
}
</style>
